export const timeChoose = Array.from({ length: 34 }, (_, i) => {
  const time = new Date(7, 7, 7, 7, 30 * i)
  const timeRu = time.toLocaleTimeString('ru-Ru', {
    hour: '2-digit',
    minute: '2-digit',
  })
  return {
    id: timeRu,
    time: timeRu,
  }
})

export const timeChooseFifteen = Array.from({ length: 68 }, (_, i) => {
  const time = new Date(7, 7, 7, 7, 15 * i)
  const timeRu = time.toLocaleTimeString('ru-Ru', {
    hour: '2-digit',
    minute: '2-digit',
  })
  return {
    id: timeRu,
    time: timeRu,
  }
})

export const timeChooseOneHour = Array.from({ length: 17 }, (_, i) => {
  const time = new Date(7, 7, 7, 7, 60 * i)
  const timeRu = time.toLocaleTimeString('ru-Ru', {
    hour: '2-digit',
    minute: '2-digit',
  })
  return {
    id: timeRu,
    time: timeRu,
  }
})

export const timeStamp = [
  { id: '15 mins', time: '15 mins' },
  { id: '30 mins', time: '30 mins' },
  { id: '1 hour', time: '1 hour' },
]
